import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';
import Dropdown from '../components/Dropdown.js';
import Table from '../components/Table.js';
import UsersView from './UsersView.js';

export default class AppUsersView extends BaseView {

    init() {
        super.init();
        const self = this;
        if ($('#appusers').length > 0) {
            this.table = new Table('appusers', '/api/users/tablebyapp', [
                {data: 'select', orderable: false},
                {data: 'firstname'},
                {data: 'lastname'},
                {data: 'email'},
                //{ data: 'created_at' },
                {data: 'lastlogin'},
                {data: 'roles'},
                {data: 'tools', orderable: false},
            ]);

            this.menu = new Dropdown('#appusersPageMenu', {
                onAssign: function (ids) {
                    if (ids.length > 0) {
                        Api.getTpl('userrole-form').done(function (r) {
                            Api.send('/api/role').done(function (roles) {
                                const tpl = _.template(r);
                                Confirm({
                                    ok: Lang.save,
                                    title: Lang.userroleTitle,
                                    msg: tpl({roles: roles}),
                                    onConfirm: function () {
                                        self.addRoles(ids);
                                    }
                                });
                            });
                        });
                    }
                }
            });
        }
    }


    setEvents() {
        const self = this;
        const section = $('#appusersGroup');

        //Edit
        section.off("click.appuserse").on("click.appuserse", ".edit", function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/users/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        section.off("click.appuserd").on("click.appuserd", ".delete", function () {
            const roleid = $(this).data('roleid');
            const userid = $(this).data('userid');
            Api.send(`/api/role/${roleid}/user/${userid}`, {}, 'delete').done(function () {
                self.table.reload();
            });
        });

        section.on('click.appaddu', '.add', function () {
            self.addUser();
            return false;
        });

        section.on('click.appcreateu', '.create', function () {
            self.renderForm();
            return false;
        });
    }

    renderForm(user) {
        const self = this;
        let method, url;
        if (!user) {
            user = {
                firstname: '',
                lastname: '',
                email: ''
            };
            method = 'post';
            url = '/api/users?newguest=1';
        } else {
            method = 'patch';
            url = `/api/users/${user.id}`;
        }

        Api.send('/api/role').done(function (roles) {
            Api.getTpl('appusers').done(function (r) {
                const tpl = _.template(r);
                let vald = false;

                Confirm({
                    ok: Lang.save,
                    title: Lang.userinfo,
                    classes: 'large-modal',
                    msg: tpl({user: user, roles: roles}),
                    onValidate: function () {
                        vald = UsersView.validate();
                        return vald;
                    },
                    onConfirm: function () {
                        if (vald) {
                            const data = $('#userForm').aeroSerialize();
                            //data.sysadmin = !!(data.sysadmin);
                            data.orgadmin = !!(data.orgadmin);
                            Api.send(url, data, method).done(function () {
                                self.table.reload();
                            });
                            return true;
                        }
                    }
                });
            });
        });
    }

    addRoles(ids) {
        const self = this;
        const data = $('form').aeroSerialize();

        $.each(ids, function (key, val) {
            data.userid = val;
            Api.send('/api/role/adduser', data, 'post').done(function () {
                self.table.reload();
            });
        });
    }

    addUser() {
        const self = this;
        Api.getTpl('roleuser-form').done(function (r) {
            Api.send('/api/users', {org: $('[data-org]').data('org')}).done(function (users) {
                const tpl = _.template(r);
                Confirm({
                    ok: Lang.save,
                    title: Lang.associateapp,
                    msg: tpl({users: users}),
                    onConfirm: function () {
                        const data = $('form').aeroSerialize();
                        Api.send(`/api/users/addguests`, data, 'post').done(function () {
                            self.table.reload();
                        });
                    }
                });
            });
        });
    }
}
